module.exports = __webpack_public_path__ + "static/media/bg.96eb6f61.webp";